/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';

interface Props {
  goNext: () => void;
  goPrevious: () => void;
  isDisabled?: boolean;
}

export const NavigationButtons = (props: Props) => {
  const { goNext, goPrevious, isDisabled } = props;

  if (isDisabled) {
    return null;
  }

  return (
    <div className='navigation-buttons text-center d-flex align-items-center'>
      <div className='pl-2'>
        <Button color='link' className='w-100 text-nowrap py-0'
                onClick={goPrevious}>
          <i className='fa fa-chevron-left mr-2 text-ThemeAccentMedium' />prev
        </Button>
      </div>
      <div className='align-self-center mx-2 text-primary'><span>&#47;</span></div>
      <div>
        <Button color='link' className='w-100 text-nowrap py-0'
                onClick={goNext}>next
          <i className='fa fa-chevron-right ml-2' />
        </Button>
      </div>
    </div>
  )
}
